import { IPromise, IQService } from 'angular';
import { FoundryService, IFoundryModel } from '../tn.common';
import DjangoClient, {
    IPagedResult,
} from '../tn.django/django-client.service/djangoClient';

export interface IDjangoSeries {
    id: 1;
    name: string;
    slug: string;
    released: string; // we may want to tranform this to DateTime on load
    // array of family ids in the series.
    family: number[];
    // array of designer ids in the series
    designers: number[];
    foundry: number;
    description: string;
    description_link: string[];
    starting_price: number;
    style_count: number;
}

export interface ISeries extends IDjangoSeries {
    canonical_foundry: IFoundryModel;
}

export class SeriesRepository {
    static $inject = ['djangoClient'];
    constructor(protected djangoClient: DjangoClient) {}

    getSeries(id: number): IPromise<IDjangoSeries> {
        return this.djangoClient.get<IDjangoSeries>('/api/1/series/' + id);
    }

    list(): IPromise<IPagedResult<IDjangoSeries>> {
        return this.djangoClient.getPaged<IDjangoSeries>('/api/1/series/');
    }
}

export class SeriesService {
    _updatePromise;
    series: ISeries[] = [];
    seriesIdxBySlug: Record<string, ISeries> = {};
    seriesIdxById: Record<number, ISeries> = {};

    static $inject = ['$q', 'seriesRepository', 'foundryService'];
    constructor(
        protected $q: IQService,
        protected seriesRepository: SeriesRepository,
        protected foundryService: FoundryService
    ) {}

    _updateSeries(): IPromise<ISeries[]> {
        if (!this._updatePromise) {
            this._updatePromise = this.seriesRepository
                .list()

                .then((res) => {
                    this.series = res.results.map((djangoSeries) => {
                        const canonical_foundry =
                            this.foundryService.djangoFoundriesIdxByDjanoId[
                                djangoSeries.foundry
                            ];
                        const series = Object.assign({}, djangoSeries, {
                            canonical_foundry,
                        });
                        this.seriesIdxById[series.id] = series;
                        this.seriesIdxBySlug[series.slug] = series;
                        return series;
                    });
                })
                .catch((e) => {
                    this._updatePromise = null;
                    throw e;
                });
        }

        return this._updatePromise;
    }

    listSeries(): Record<number, ISeries> {
        return this.seriesIdxById;
    }

    getSeries(slug: string): IPromise<ISeries> {
        return this._updateSeries().then(() => {
            return this.seriesIdxBySlug[slug];
        });
    }

    getSeriesById(id: number): IPromise<ISeries> {
        return this._updateSeries().then(() => {
            return this.seriesIdxById[id];
        });
    }

    getSeriesByIds(ids: number[]): IPromise<ISeries[]> {
        return this._updateSeries().then(() => {
            return ids.map((id) => this.seriesIdxById[id]);
        });
    }
}
